





















import {
  DryingLabel,
  localizeDryingLabel,
} from "@/data/models/ProgramChainQualityRating";
import { Vue, Component, Model, Prop } from "vue-property-decorator";

@Component
export default class LabelDryingComponent extends Vue {
  @Prop({ default: true })
  editEnabled!: boolean;

  @Model("labels")
  labels!: DryingLabel[];

  groupedLabels = this.calculateGroupedLabels();

  isChecked(dryingLabel: DryingLabel) {
    return this.labels.includes(dryingLabel);
  }

  toggle(dryingLabel: DryingLabel) {
    const update = this.labels.includes(dryingLabel)
      ? this.labels.filter((label) => label !== dryingLabel)
      : [...this.labels, dryingLabel];

    this.$emit("labels", update);
  }

  calculateGroupedLabels() {
    const labels = [
      DryingLabel.NO_PLASTIC_SHEETING_ON_RAW_FLOOR,
      DryingLabel.UNDERFLOOR_HEATING,

      DryingLabel.NEW_MOISTURE_APPEARED,
      DryingLabel.NIGHTLY_INTERRUPTION_BY_CLIENT,

      DryingLabel.INSUFFICIENT_AIR_FLOW,
      DryingLabel.RELAY_MALFUNCTION,

      DryingLabel.MOISTURE_NEAR_DRILL_HOLES,
      DryingLabel.DRYING_WITH_PRE_DRIED_AIR,
    ];

    const groupSize = 2;
    const result: DryingLabel[][] = [];

    for (let i = 0; i < labels.length; i += groupSize) {
      result.push(labels.slice(i, i + groupSize));
    }

    return result;
  }

  localizeLabel(dryingLabel: DryingLabel) {
    return localizeDryingLabel(this, dryingLabel);
  }
}
